import { ButtonRoot } from '@/components/common/Button'
import { FloatingHover } from '@/components/common/Floating'
import { PriceSource } from '@/components/common/PriceSource'
import { Icon } from '@/components/icons/Icon'
import { type CardIdType } from '@/defs/card'
import { useCard } from '@/hooks/useCard'
import { usePriceSources } from '@/hooks/usePriceSources'
import { cn } from '@/utils/commonUtil'

import styles from './CardFacePrices.module.scss'
import { CardFacePricesMore } from './CardFacePricesMore/CardFacePricesMore'

const VISIBLE_COUNTS = [1, 2, 3]

type Props = {
  cardId: CardIdType
  enabled?: boolean
}

export const CardFacePrices = ({ cardId, enabled }: Props) => {
  const { card, hasError, loading } = useCard({ cardId, enabled })
  const priceSources = usePriceSources()

  if (loading || hasError || !card?.priceSources || card.hasContentWarning) return <div className={styles.container} />

  return (
    <div className={styles.container}>
      <ul className={styles.pricesMain}>
        {priceSources.slice(0, 3).map((priceSource) => (
          <li key={priceSource}>
            <PriceSource card={card} colorScheme='light' priceSource={priceSource} />
          </li>
        ))}
      </ul>
      {VISIBLE_COUNTS.map(
        (visibleCount) =>
          priceSources.length > visibleCount && (
            <FloatingHover
              content={<CardFacePricesMore card={card} priceSources={priceSources.slice(visibleCount)} />}
              key={visibleCount}
            >
              <ButtonRoot
                aria-label='View More Prices'
                className={cn(styles.more, { styles, visibleCount: String(visibleCount) })}
              >
                <Icon name='caret' />
              </ButtonRoot>
            </FloatingHover>
          ),
      )}
    </div>
  )
}
